import React from 'react';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import AppointmentEventForm from './AppointmentEventForm';
import BookingPagesWrapper from './BookingPagesWrapper';
import AppointmentConfirmation from './AppointmentConfirmation';
import AppointmentAvailabilities from './AppointmentAvailabilities';
import AppointmentConfirmed from './AppointmentConfirmed';
import Thankyou from './Thankyou';

function AppointmentBooking() {
  const { Switch, Route, useRouter } = useAppContext();

  const router = useRouter();
  const { match: { url } } = router;

  const scopedPath = (path) => `${url}${path}`;

  const startAt = `${process.env.PROXY_PATH}/booking/onboarding`;

  const options = {
    'client-id': process.env.CLIENT_ID,
    currency: 'USD',
    intent: 'authorize',
    locale: 'en_US',
  };

  return (
    <Switch>
      <BookingPagesWrapper>
        {/* STEP 2 */}
        <Route exact path={scopedPath('/availabilities')}>
          <AppointmentAvailabilities proceedTo={scopedPath('/event_form')} />
        </Route>

        {/* STEP 3 */}
        <Route exact path={scopedPath('/event_form')}>
          <AppointmentEventForm proceedTo={scopedPath('/confirmation')} />
          {/* <AppointmentForm /> */}
        </Route>

        {/* STEP 4 */}
        <Route exact path={scopedPath('/confirmation')}>
          <PayPalScriptProvider options={options}>
            <AppointmentConfirmation proceedTo={scopedPath('/confirmed')} />
          </PayPalScriptProvider>
        </Route>
        {/* STEP 5 */}
        <Route exact path={scopedPath('/confirmed')}>
          <AppointmentConfirmed confirmed proceedTo={scopedPath('/thankyou')} />
        </Route>

        {/* STEP 6 */}
        <Route exact path={scopedPath('/thankyou')}>
          <Thankyou />
        </Route>
      </BookingPagesWrapper>
    </Switch>
  );
}

export default AppointmentBooking;
